module.exports = __webpack_public_path__ + "img/star4.b0f34a28.png";